import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Wallet } from 'lucide-react';
import { Profile, Withdrawal } from '../components';

type Tab = 'profile' | 'wallet';

export function ProfilePage() {
  const [activeTab, setActiveTab] = useState<Tab>('profile');

  return (
    <div className="space-y-6">
      {/* Tab selector */}
      <div className="flex gap-2 p-1 bg-white/5 rounded-xl">
        <button
          onClick={() => setActiveTab('profile')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all ${
            activeTab === 'profile'
              ? 'bg-primary text-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          <User className="w-5 h-5" />
          Profile
        </button>
        <button
          onClick={() => setActiveTab('wallet')}
          className={`flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all ${
            activeTab === 'wallet'
              ? 'bg-primary text-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          <Wallet className="w-5 h-5" />
          Withdraw
        </button>
      </div>

      {/* Tab content */}
      <AnimatePresence mode="wait">
        {activeTab === 'profile' && (
          <motion.div
            key="profile"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="space-y-6"
          >
            <Profile />
          </motion.div>
        )}
        {activeTab === 'wallet' && (
          <motion.div
            key="wallet"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            className="space-y-6"
          >
            <Withdrawal />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
